import { Menu as AntMenu } from 'antd';
import styled, { createGlobalStyle, css } from 'styled-components';

export const MenuStyle = css`
  border-right: 0;

  .ant-menu-item,
  .ant-menu-submenu-title {
    border: 0;
    height: var(--height-base);
    line-height: var(--height-base);
    margin-bottom: 0;
    margin-top: 0;
    padding-left: var(--left-spacing) !important;
  }
  /*
  .ant-menu-submenu-arrow {
    &::before {
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid var(--gray-40);
      transform: none;
    }

    &::after {
      display: none;
    }
  }

  .ant-menu-submenu-open .ant-menu-submenu-arrow::before {
    transform: rotate(180deg);
  }*/

  .ant-menu-sub .ant-menu-item {
    font-weight: normal;
    padding-left: var(--spacing-08) !important;
    padding-right: var(--spacing-03);
  }

  .ant-menu-item-divider {
    margin: var(--layout-01);
  }

  .ant-menu-item-selected {
    background: var(--coolest-gray-10);
    font-weight: var(--heading-7-weight);
  }

  &.ant-menu-light {
    .ant-menu-submenu-active,
    .ant-menu-item-active:not(.ant-menu-item-selected),
    .ant-menu-submenu-title:hover,
    .ant-menu-item:not(.ant-menu-item-selected):hover {
      background: var(--item-hover-bg);
      color: var(--gray-100);
    }
    .ant-menu-item:not(.ant-menu-item-selected) a:hover,
    .ant-submenu-item:not(.ant-menu-submenu-selected) a:hover {
      color: var(--gray-100);
    }
  }
  /* Added flex to stretch the title to the full width. With this, we can keep the plus icon of spaces at the right extreme.*/
  .ant-menu-submenu-title > span {
    flex: 1;
  }

  .ant-menu-submenu.ant-menu-submenu-selected {
    font-weight: bold;
    color: var(--text-color);
  }

  .ant-menu-item.invite-button {
    position: absolute;
    bottom: 0;
    background: var(--white-100);
    border: 1px solid var(--border-color);
    padding: var(--spacing-05) var(--spacing-06) !important;
    height: auto;
    box-sizing: border-box;
  }
`;

export const Menu = styled(AntMenu)`
  ${MenuStyle};
  .ant-menu-sub.ant-menu-inline {
    background: var(--white-100);
  }
`;

export const MenuPopupStyle = createGlobalStyle`
  .spaces__sub-menu {
    display: none;
  }
`;

const { Divider } = Menu;

export const SpacesMenuDivider = styled(Divider)`
  &.ant-menu-item-divider {
    margin-top: var(--spacing-03);
    margin-bottom: var(--spacing-03);
  }
  opacity: 0;
`;
